module.exports = __webpack_public_path__ + "static/media/car_large.f17f66cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/car_large.png
// module id = 793
// module chunks = 0